import { fg } from '@atlaskit/platform-feature-flags';

import { CONFIG_ITEM_KEYS } from '../../../config-items/config-item-keys';
import { type EditorPluginAIConfigItemMarkdown } from '../../../config-items/config-items';
import { suggestConfigItemForConfluenceTitleToolbar } from '../../../prebuilt/config-items-range/suggest/suggest';
import { type EditorPluginAIProvider } from '../../../types';
import {
	type AdjustSelectionInstruction,
	type ConfigType,
	EventHubPrompt,
	type StartPromptData,
} from '../types';

const getConfigFromProvider = (
	editorPluginAIProvider: EditorPluginAIProvider,
	configType: ConfigType,
	key: CONFIG_ITEM_KEYS,
) => {
	const provider = editorPluginAIProvider[configType];

	if (key === CONFIG_ITEM_KEYS.FREE_GENERATE) {
		return provider.baseGenerate;
	} else {
		const configItem = provider
			.getSuggestions({ inputValue: '' })
			?.find((suggestion) => suggestion.key === key);
		return configItem;
	}
};

const getConfigTypeByAdjustSelection = (
	adjustSelection?: AdjustSelectionInstruction,
): ConfigType => {
	switch (adjustSelection) {
		case 'fullDocument': {
			return 'rangeConfig';
		}
		case 'keepCurrent': {
			return 'emptyConfig';
		}
		default: {
			return 'emptyConfig';
		}
	}
};

export const getConfigItem = (
	prompt: StartPromptData['prompt'],
	editorPluginAIProvider: EditorPluginAIProvider,
	adjustSelection?: AdjustSelectionInstruction,
): EditorPluginAIConfigItemMarkdown | undefined => {
	switch (prompt) {
		case EventHubPrompt.SuggestTitle: {
			return suggestConfigItemForConfluenceTitleToolbar;
		}
		case EventHubPrompt.CustomPrompt: {
			const freeGenerate = getConfigFromProvider(
				editorPluginAIProvider,
				getConfigTypeByAdjustSelection(adjustSelection),
				CONFIG_ITEM_KEYS.FREE_GENERATE,
			);
			return freeGenerate;
		}

		case EventHubPrompt.IssueReformatter: {
			if (fg('platform.reformat-issue-with-template-in-jira_jc0pb')) {
				const issueReformatter = getConfigFromProvider(
					editorPluginAIProvider,
					'rangeConfig',
					CONFIG_ITEM_KEYS.ADD_STRUCTURE,
				);
				return issueReformatter;
			} else {
				return undefined;
			}
		}

		default: {
			return undefined;
		}
	}
};
